module.exports = __webpack_public_path__ + "img/QS.e0d58751.png";